'use client';

import { useEffect } from 'react';

import { useLatest } from 'react-use';

import type { SyncEventPayload, SyncEventType } from '@/lib/sync/events';

import { useCrossTabSync } from './use-cross-tab-sync';

type EventHandler<T extends SyncEventType> = (payload: SyncEventPayload[T]) => void;

export function useSyncEvent<T extends SyncEventType>(eventType: T, handler: EventHandler<T>) {
  const { on } = useCrossTabSync();
  const handlerRef = useLatest(handler);

  useEffect(() => {
    const unsubscribe = on(eventType, payload => {
      handlerRef.current(payload);
    });
    return unsubscribe;
  }, [on, eventType, handlerRef]);
}
